<template>
  <v-flex xs12 sm12 class="home px-2">
    <single-bar-chart />
    <bar-chart />
  </v-flex>
</template>

<script>
import SingleBarChart from '@/components/ui/charts/SingleBarChart'
import BarChart from '@/components/ui/charts/BarChart'

export default {
  name: 'home',
  components: { SingleBarChart, BarChart }
}
</script>
